import React from 'react';

import styles from 'buyside/components/presentation/ContributorDashboard/contributorDashboardStyles.scss';

const ContributorDashboardHeading: React.FC<{
  title: string;
  children?: React.ReactElement | null;
}> = ({ title, children }) => (
  <div className={styles.paneHeading}>
    <h4>{title}</h4>
    {children}
  </div>
);

export default ContributorDashboardHeading;
